import { apiRequest, apiResponse } from "@/shared/api/client";

export interface TransferHistoryItem {
  id: number;
  src?: string | null;
  dest?: string | null;
  mode?: string | null;
  type?: string | null;
  category?: string | null;
  title?: string | null;
  year?: string | null;
  tmdbid?: number | null;
  doubanid?: string | null;
  seasons?: string | null;
  episodes?: string | null;
  image?: string | null;
  download_hash?: string | null;
  status?: boolean;
  errmsg?: string | null;
  date?: string | null;
}

export interface TransferHistoryPage {
  list: TransferHistoryItem[];
  total: number;
}

export interface TransferJob {
  id?: string | null;
  path?: string | null;
  status?: string | null;
  [key: string]: unknown;
}

export function listTransferHistory(opts: {
  page?: number;
  count?: number;
  status?: boolean | null;
  title?: string;
}) {
  const params = new URLSearchParams();
  params.set("page", String(opts.page ?? 1));
  params.set("count", String(opts.count ?? 30));
  if (opts.status === true) params.set("status", "true");
  if (opts.status === false) params.set("status", "false");
  if (opts.title?.trim()) params.set("title", opts.title.trim());
  return apiResponse<TransferHistoryPage>(
    `/api/v1/history/transfer?${params.toString()}`,
  );
}

/** 按历史记录重新整理 */
export function retransferHistory(logid: number) {
  if (!Number.isInteger(logid) || logid <= 0) {
    return Promise.reject(new Error("无效的整理记录 ID"));
  }
  return apiResponse("/api/v1/transfer/manual?background=true", {
    method: "POST",
    body: { logid, from_history: true },
  });
}

/** 仅删除记录，不删文件 */
export function deleteTransferHistory(id: number) {
  if (!Number.isInteger(id) || id <= 0) {
    return Promise.reject(new Error("无效的整理记录 ID"));
  }
  return apiResponse("/api/v1/history/transfer", {
    method: "DELETE",
    body: { id },
  });
}

export function listTransferQueue() {
  return apiRequest<TransferJob[]>("/api/v1/transfer/queue");
}
